import { AgentKnowledgeStatus } from "@redotech/cockroachdb-codegen/tables/agent-knowledge/agent-knowledge-status";
import {
  productKnowledgeDraftSchema,
  productKnowledgeEntrySchema,
} from "@redotech/shopper-agent-knowledge-common/product-knowledge-view";
import { productKnowledgeIdFormat } from "@redotech/shopper-agent-knowledge-id";
import * as z from "zod";

/** The draft is written whole, so the product links always match what was shown. */
export const updateProductKnowledge = {
  name: "updateProductKnowledge" as const,
  input: z.object({
    id: productKnowledgeIdFormat.schema,
    draft: productKnowledgeDraftSchema,
    status: z.enum(AgentKnowledgeStatus).optional(),
  }),
  output: productKnowledgeEntrySchema,
};
